import React from 'react';
import { connect } from 'react-redux';
import classes from './Meals.scss';

import CommonWrapper from '../Common/CommonWrapper/CommonWrapper';
import MealsSelect from './MealsSelect/MealsSelect';
import MealsPaxSelect from './MealsPaxSelect/MealsPaxSelect';
import MealsPaxSelectMobile from './MealsPaxSelectMobile/MealsPaxSelectMobile';
import MealsNav from './MealsNav/MealsNav';

import HeadingH1 from '../../UI/Headings/HeadingH1/HeadingH1';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';

import mealsImage from './img/meals.png';
import Media from 'react-media';

const meals = (props) => {
    let mealKeysOneWay = null;
    let mealKeysReturn = null;
    if (props.meals.O) {
        mealKeysOneWay = Object.keys(props.meals.O).filter((keyCode) => {
            return props.meals.O[keyCode].mealOptions.length !== 0;
        });
    }
    if (props.meals.R) {
        mealKeysReturn = Object.keys(props.meals.R).filter((keyCode) => {
            return props.meals.R[keyCode].mealOptions.length !== 0;
        });
    }
    return (
        <React.Fragment>
            <div className={classes.Nav}>
                {
                    mealKeysOneWay.length > 0 ? <div>
                        <MealsNav type='depart' meals={props.meals.O} mealsView={props.mealsViewO} mealsFlow={props.mealsFlow} flow='O' />
                    </div> : <div>
                        <p className="u-fontSize13 u-textColorNormal u-fontWeightRegular">Meal selection is not available for departure flight.</p>
                    </div>
                }
                {
                    props.flightType === "R" ?  
                    props.meals.R && mealKeysReturn.length > 0 ? <div style={{ backgroundColor: '#D9DEEC' }}>
                    <MealsNav type='return' meals={props.meals.R} mealsView={props.mealsViewR} mealsFlow={props.mealsFlow} flow='R' />
                    </div> : <div>
                        <p className="u-fontSize13 u-textColorNormal u-fontWeightRegular">Meal selection is not available for return flight.</p>
                    </div> : null
                }                
            </div>
            <CommonWrapper>
                <div className={classes.MealsLeft}>
                    <div className={`mb-4`}>
                        <HeadingH3 size={16} weight="Medium" color="Dark">Select Meal</HeadingH3>
                    </div>
                    <div className={classes.MealsSelect}>
                        <MealsSelect meals={props.meals} mealsViewO={props.mealsViewO} mealsViewR={props.mealsViewR} flow={props.mealsFlow}/>
                    </div>
                </div>
                <div className={`${classes.MealsRight} u-phoneHide`}>
                    { (props.selectedMeals[props.mealsFlow] === {} && props.passengers.length > 1) || props.passengers.length === 1 ? null : <h3 className={`u-fontSize16 u-fontWeightRegular u-textColorDark mb-4`}>Select Passengers</h3> }
                    { 
                        (props.selectedMeals[props.mealsFlow] === {} && props.passengers.length > 1) || props.passengers.length === 1 ? 
                        <div className={`u-flex align-items-center justify-content-between u-height100Percent`}>
                            <div className={classes.Image}>
                                <div className={`mb-4`}>
                                    <img src={mealsImage} alt='Meals' className="u-width50Percent"/>
                                </div>
                                <div className={`mb-2`}>
                                    <HeadingH1 size={26} weight="Light" color="Dark">Get discount on meals!</HeadingH1>
                                </div>
                                <HeadingH3 size={13} weight="Regular" color="Light">Pre-booked meals are 20% cheaper than on-board price</HeadingH3>
                            </div>
                        </div> : <MealsPaxSelect amount={props.selectedMeals[props.mealsFlow][props.mealsFlow === 'O' ? props.mealsViewO : props.mealsViewR].amt} flow={props.mealsFlow} />
                    } 
                </div>
                <Media query="(max-width: 599px)">
                    {matches =>
                        matches && props.selectedMeals[props.mealsFlow][props.mealsFlow === 'O' ? props.mealsViewO : props.mealsViewR].typ && props.passengers.length > 1 && props.displayPax ? <MealsPaxSelectMobile flow={props.mealsFlow} /> : null }
                </Media>
            </CommonWrapper>
        </React.Fragment>
    );
}

const mapStateTopProps = state => {
    return {
        meals: state.farePrice.generalData.data.meals,
        mealsViewO: state.farePrice.mealsViewOneWay,
        mealsViewR: state.farePrice.mealsViewReturn,
        mealsFlow: state.farePrice.mealsFlow,
        passengers: state.farePrice.passengers,
        displayPax: state.farePrice.displayPax,
        selectedMeals: state.farePrice.selectedMeals,
        flightType: state.farePrice.flightType
    }
}

export default connect(mapStateTopProps)(meals);


// WEBPACK FOOTER //
// ./src/components/Addons/Meals/Meals.js